export const tablefields = [
	// {
	// 	'name': 'Project',
	// 	'order': '1',
	// 	'value': 'title',
	// 	'width': 200,
	// 	'class': 'AlignLeft',
	// },
	{
		'name': 'Country',
		'order': '2',
		'value': 'name',
		'type': 'back_translate',
		'width': 200,
		'class': 'AlignLeft',
	},
	{
		'name': 'Date',
		'order': '3',
		'value': 'date',
		'type': 'date',
		'width': 100
	},
	{
		'name': 'Description',
		'order': '4',
		'value': 'description',
		'width': 400,
		'class': 'AlignLeft',
	},
]